import { request } from "@/api";
import type { Rates } from "@/shared/types";

export const fetchRates = async () => {
  return request<Rates>("/rates");
};
